import { IonContent } from '@ionic/react';
import React, { ReactNode, useContext } from 'react';
import { useMeasure } from 'react-use';

interface IonContentWithContextProps {
  children: ReactNode;
}

interface ContentContext {
  height: number;
}

const ContentContext = React.createContext<ContentContext | undefined>(
  undefined
);

const IonContentWithContext = (props: IonContentWithContextProps) => {
  const { children } = props;
  const [contentRef, { height }] = useMeasure<HTMLIonContentElement>();
  return (
    <IonContent ref={contentRef}>
      <ContentContext.Provider value={{ height }}>
        {children}
      </ContentContext.Provider>
    </IonContent>
  );
};

const useIonContentContext = (): ContentContext | undefined => {
  const results = useContext(ContentContext);
  return results;
};

export { IonContentWithContext, useIonContentContext };
